

export const FooterComponent = () => {
    return (
        <footer className="footer">
            © Copyright 2023 GrupoMost v1 <span className="d-none d-sm-inline-block"></span>
        </footer>
    )
}